import { InjectionToken } from "@angular/core";

export interface EnvironmentStatusConfig {
    fileUrl: string;
    envName: string;
}
export const ENVIRONMENT_STATUS_CONFIG = new InjectionToken<EnvironmentStatusConfig>(
    "Configuration for environment status",
);
